// extracted by mini-css-extract-plugin
module.exports = {"SPopularMoviesList":"PopularMoviesList_SPopularMoviesList__Jhetq","SPopMoviesHeader":"PopularMoviesList_SPopMoviesHeader__LCR_d"};